import React, { createContext, useContext, useState } from 'react';

const ChatContext = createContext<any>(undefined);

export const ChatProvider = ({ children }: any) => {
	const [showViewLastMessages, setShowViewLastMessages] = useState(false);
	const [isOpenChatParticipants, setIsOpenChatParticipants] = useState(false);

	const handleChatParticipants = () => {
		setIsOpenChatParticipants(!isOpenChatParticipants);
	};

	const value = {
		showViewLastMessages,
		setShowViewLastMessages,
		isOpenChatParticipants,
		setIsOpenChatParticipants,
		handleChatParticipants,
	};

	return <ChatContext.Provider value={value}>{children}</ChatContext.Provider>;
};

export const useChat = () => {
	const context = useContext(ChatContext);
	if (!context) {
		throw new Error('useChat must be used within a ChatProvider');
	}
	return context;
};
